import { Component, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ProjectService } from '@app/main/projects-new/Services/project.service';
import { HeaderTitle } from '@app/shared/common/header-title/header-title.model';
import { HeaderTitleService } from '@app/shared/common/header-title/header-title.service';
import { BreadcrumbItem } from '@app/shared/common/sub-header/sub-header.component';
import { AppComponentBase } from '@shared/common/app-component-base';
@Component({
    selector: 'help-section-content',
    templateUrl: './help-section-content.component.html',
    styleUrls: ['./help-section-content.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class HelpSectionContentComponent extends AppComponentBase implements OnInit {
    bgColorList: string;

    constructor(
        injector:Injector,
        private _router: Router,
        private router: Router,
        private headerTitleService: HeaderTitleService,
        public projectService: ProjectService) {super(injector);
    }

    tabIndexFinal: any;
    tabIndex: any;


    ngOnInit(): void {
        
        this.bgColorList = 'bg-dark';
        this.tabIndexFinal = this.projectService.getCardList();
        if (this.tabIndexFinal) {
            if (this.tabIndexFinal[0] == '' || this.tabIndexFinal[0] == null || this.tabIndexFinal[0] == undefined) {
                const event = 'My Profile';
                this.toggleBtn(event);
                this.accordianOpen(0);
            } else {
                const event = this.tabIndexFinal[0];
                this.toggleBtn(event);
                setTimeout(() => {
                    this.accordianOpen(this.tabIndexFinal[1])
                }, 100);
            }
        }
      
    }


    visited = [0, 0, 0, 0, 0, 0];
    number = ["One", "Two", "Three", "Four", "Five", "Six"];

    accordianOpen(id: number) {
        for (let i = 0; i < 6; i++) {
            if (this.visited[i] === 1) {
                if (document.getElementById("collapse" + this.number[i])) {
                    document.getElementById("collapse" + this.number[i]).className = "collapsing";
                }
                if (document.getElementById("heading" + this.number[i])) {
                    document.getElementById("heading" + this.number[i]).className = "collapsed card-head";
                }

                this.visited[i] = 0;
                if (id === i) {
                    break;
                }
            }
            if (document.getElementById("collapse" + this.number[i])) {
                document.getElementById("collapse" + this.number[i]).className = "collapsing";
            }
            if (document.getElementById("heading" + this.number[i])) {
                document.getElementById("heading" + this.number[i]).className = "collapsed card-head";
            }

            if (id === i) {
                if (document.getElementById("collapse" + this.number[i])) {
                    document.getElementById("collapse" + this.number[i]).className = "show";
                }
                if (document.getElementById("heading" + this.number[i])) {
                    document.getElementById("heading" + this.number[i]).className = "card-head";
                }

                this.visited[i] = 1;
            }
        }
    }

    viewRoleRedirect() {
        this._router.navigate(['/app/main/CommonUiElements/help_section_content']);
    }
    homePage() {
        this._router.navigate(['/app/main/CommonUiElements/help_section']);
    }
    listArray: any[] = [
        { id: 1, isShown: true, label: 'MyProfile' },
        { id: 2, isShown: false, label: 'Clients' },
        { id: 3, isShown: false, label: 'Projects' },
        { id: 4, isShown: false, label: 'Leaves' },
        { id: 5, isShown: false, label: 'Activities' },
        { id: 6, isShown: false, label: 'TimeTracking' },
        { id: 7, isShown: false, label: 'Timesheet' },
        { id: 8, isShown: false, label: 'CompanyProfile' },
        { id: 9, isShown: false, label: 'OrganizationUnit' },
        { id: 10, isShown: false, label: 'ProductAndServices' },
        { id: 11, isShown: false, label: 'ManageUsers' },
        { id: 12, isShown: false, label: 'AppProductivity' },
        { id: 13, isShown: false, label: 'DownloadAgentApp' },
       
      
    ];

    toggleBtn(event: string) {
        this.bgColorList = '';
        this.headerTitleService.setPageTitle(new HeaderTitle([
            new BreadcrumbItem(this.l('HelpSection')),
            new BreadcrumbItem(this.l(event))
        ]));
        const list = this.listArray;
        const clickedListItem = this.listArray.find(x => x.label == event);
        for (let i = 0; i < this.listArray.length; i++) {
            document.getElementById(list[i].label).style.backgroundColor = '#000000';
            list[i].isShown = false;
        }
        clickedListItem.isShown = true;
        document.getElementById(event).style.backgroundColor = '#0095DA';
    }
}
